import { render, staticRenderFns } from "./addUrl.vue?vue&type=template&id=5f13658c&scoped=true"
import script from "./addUrl.vue?vue&type=script&lang=js"
export * from "./addUrl.vue?vue&type=script&lang=js"
import style0 from "./addUrl.vue?vue&type=style&index=0&id=5f13658c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13658c",
  null
  
)

export default component.exports